export default import.meta.ROLLUP_FILE_URL_fQyoR3m0eA3DLqol7kyoXA;